/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import { mergeSx } from "@/src/utils/mergeSx";
import { Alert, AlertProps } from "@mui/material";
import { alertLegalbirdStyle } from "./alertLegalbirdStyle.ts";

export type AlertLegalbirdProps = {
  variant?: "hint" | AlertProps["variant"];
} & Omit<AlertProps, "variant">;

export default function AlertLegalbird({ variant, severity, sx, ...muiAlertProps }: AlertLegalbirdProps) {
  const isHint = variant === "hint";

  return (
    <Alert
      {...muiAlertProps}
      icon={!isHint ? null : false}
      severity={severity}
      sx={mergeSx(
        isHint && alertLegalbirdStyle.hint,
        isHint && severity === "success" && alertLegalbirdStyle.hintSuccess,
        isHint && severity === "warning" && alertLegalbirdStyle.hintWarning,
        isHint && severity === "error" && alertLegalbirdStyle.hintError,
        sx,
      )}
    />
  );
}
